import { type FC, type ReactNode } from "react";

import { Input, TooltipIndicator, TooltipPlacementTypes } from "@snapchat/snap-design-system";

import { Flexbox } from "../../../shared/components";
import { FOLDERS_AND_ORG_NAME_MAX_CHARS } from "../constants";

import { LensFolder, LensFolderTooltip, Organization, OrganizationTooltip } from "./messages.generated";
import { sectionHeader, sectionHeaderMargin, sectionMargin } from "./shared.styles";

interface TextInputSectionProps {
    isLoading: boolean;
    inputValue: string;
    onChange: (value: string) => void;
    tooltipText: ReactNode;
    sectionHeaderText: ReactNode;
}

const TextInputSection: FC<TextInputSectionProps> = ({
    isLoading,
    inputValue,
    onChange,
    tooltipText,
    sectionHeaderText,
}) => {
    return (
        <div className={sectionMargin}>
            <Flexbox alignItems="center" className={sectionHeaderMargin}>
                <div className={sectionHeader}>{sectionHeaderText}</div>
                <TooltipIndicator content={tooltipText} placement={TooltipPlacementTypes.TOP} />
            </Flexbox>
            <Input
                value={inputValue}
                onChange={onChange}
                disabled={isLoading}
                maxLength={FOLDERS_AND_ORG_NAME_MAX_CHARS}
            />
        </div>
    );
};

interface TextInputSectionContainerProps {
    isLoading: boolean;
    inputValue: string;
    onChange: (value: string) => void;
}

export const LensSpaceTextInputSection: FC<TextInputSectionContainerProps> = ({ isLoading, inputValue, onChange }) => {
    return (
        <TextInputSection
            sectionHeaderText={<LensFolder />}
            inputValue={inputValue}
            onChange={onChange}
            tooltipText={<LensFolderTooltip />}
            isLoading={isLoading}
        />
    );
};

export const OrganizationTextInputSection: FC<TextInputSectionContainerProps> = ({
    isLoading,
    inputValue,
    onChange,
}) => {
    return (
        <TextInputSection
            sectionHeaderText={<Organization />}
            inputValue={inputValue}
            onChange={onChange}
            tooltipText={<OrganizationTooltip />}
            isLoading={isLoading}
        />
    );
};
